const ruleMixin = {
  data() {
    var checkNum = (rule, value, callback) => {
      if(value!=0){
        if (!value) {
          return callback(new Error('不能为空或者为0'));
        }
      }
     
      setTimeout(() => {
        // if (!Number.isInteger(value)) {
        if (isNaN(value)) {
          callback(new Error('请输入数字值'));
        } else {
          if (value < 0) {
            callback(new Error('必须大于或者等于0'));
          } else {
            callback();
          }
        }
      }, 1000);
    }
    // var checkList = (rule, value, callback) => {
    //   console.log(value)
    //   if (!value ||(!value.length)) {
    //     return callback(new Error('请选择111'));
    //   }
    // }
    var checkobj = (rule, value, callback) => {
      console.log(rule)
      console.log(value)
      if (!value ) {
        return callback(new Error('请选择111'));
      }
    }

    var checkHas = (rule, value, callback) => {
    
      if (!value ) {
        return callback(new Error('输入'));
      }
    }
    return {
      //rules前端验证
      rules: {
        bondCode: [{ required: true, message: '填写债券代码', name: '债券代码', trigger: 'blur' }], // 商品代码
        bondName: [{ required: true, message: '填写债券名称', name: '债券名称', trigger: 'blur' }], // 债券名称
        balance: [{ required: true, message: '填写当前余额', name: '当前余额', trigger: 'blur' }], // 当前余额
        bondType: [{ required: true, message: '填写债券类型', name: '债券类型', trigger: 'blur' }], // 债券类型 
        market: [{ required: true, message: '填写债券市场', name: '债券市场', trigger: 'blur' }], // 债券市场
        rateType: [{ required: true, message: '填写利率类型', name: '利率类型', trigger: 'blur' }], // 利率类型
        
        rate: [{ required: true, message: '填写票面利率', name: '票面利率', trigger: 'blur' }], // 票面利率
        issuePrice: [{ required: true, message: '填写发行价格', name: '发行价格', trigger: 'blur' }], // 发行价格
        

        goodsName: [{ required: true, message: '填写商品名称', name: '商品名称', trigger: 'blur' }], // 商品名称
        goodsNameEn: [{ required: true, message: '请填写商品英文名字', trigger: 'blur' }], // 商品因为名称
        cateMaId:[{ required: true, message: '请选择', trigger: 'change' }],
        cateTypeId: [{ required: true, message: '请选择', trigger: 'change' }], // 商品品类
        cateMaterialId: [{ required: true, message: '请选择', trigger: 'change' }], // 商品材质类别
        cateMainId: [{ required: true, message: '请选择', trigger: 'change' }], // 商品展示类别
        stock: [{ required: true, message: '请填写库存', trigger: 'blur' }], // 商品库存
        saleNum: [{ required: true, message: '请填写商品数量', trigger: 'blur' }], // 销售数量
        sort: [{ required: false, message: '请填写排序', trigger: 'blur' }, { type: 'number', message: '排序必须为数字' }], // 排序
        purchaseLimit: [{ required: false, message: '请填写排序', trigger: 'blur' }, { type: 'number', message: '排序必须为数字' }],// 限购
        
        material: [{ required: true, message: '请填写商品材质', trigger: 'blur' }],   // 商品材质
        goodsvalue: [{ required: true, message: '请填写', trigger: 'blur' }],  // 推荐商品
        salePrice: [{ required: true, validator: checkNum, trigger: 'blur' }], // 销售价格
        vipPrice: [{ required: true, validator: checkNum, trigger: 'blur' }],   // vip价格
        marketPrice: [{ required: true, validator: checkNum, trigger: 'blur' }],  // 市场价格
        isSale: [{ required: true, message: '请选择是否上下架', trigger: 'change' }],  // 是否上架
        indexImg: [{ required: true, message: '请上传首页展示图' }],
        coverImg: [{ required: true, message: '请上传商品主展示图' }],
        bannerImg: [{ required: true, message: '请上传详情页轮播图' }],
        showInDesImg: [{ required: true, message: '请上传推荐分享图' }],
        img: [{ required: true, message: '请上传图片' }],
        activityName: [{ required: true, message: '请请填写活动名称', trigger: 'blur' }], // 活动名称
        activityStartTime: [{ required: true, message: '请选择', trigger: 'change' }],// 活动开始时间
        activityEndTime: [{ required: true, message: '请选择', trigger: 'change' }],// 活动开始时间
        // endTime: [{ required: true, validator: checkList, trigger: 'change' }],// 选择商品列表
        goodsIdList: [{required: true,message: '至少选择一个商品', trigger: 'change' } ],
        goodsIds: [{ required: true, trigger: 'change' ,validator: checkobj}],// 选择商品列表
        goodsSnList: [{ required: true, message: '请选择', trigger: 'blur', type: 'array' }],// 选择商品列表
        num: [{ required: true, validator: checkNum, trigger: 'blur' }],//普通数字校验
        input: [{ required: true, message: '请填写', name: '商品名称', trigger: 'blur' }], // 普通input校验
        goodsValue: [{ required: true, message: '请填写', name: '商品名称', trigger: 'blur' }], // 普通input校验
        select: [{ required: true, message: '请选择', trigger: 'change',validator:checkHas }],  // 普通change校验
      }
    }
  },
}
export default ruleMixin